import "../../styles/Components/faq/faqPublic.css";
import { BiChevronLeft } from "react-icons/bi";
import { useNavigate } from "react-router";
import { MdOutlineSmartToy, MdOutlineHelpOutline } from "react-icons/md";
import FaqItem from "./general/FaqItem";
import styles from "../../styles/Components/faq/BotFAQ.module.css";

const questions = [
  {
    question: "Do you offer automated bot trading capabilities?",
    answer:
      "Absolutely! We provide powerful tools to quickly create your bots based on your risk preferences and other parameters. Additionally, you can backtest your bots before deploying them on the exchange. Our bots leverage super-accurate trading signals generated by next-gen AI for profitable trading.",
  },
  // {
  //   question:
  //     "How do I determine the optimal parameters to make my bot profitable?",
  //   answer:
  //     "We've extensively tested various parameters, evaluating bot performance. You can leverage different parameter categories to tailor your bot for profitability.",
  // },
  {
    question:
      "How do I determine the optimal parameters to make my bot profitable?",
    answer:
      "We've extensively tested various parameters, evaluating bot performance. You can leverage different parameter categories to tailor your bot for profitability.",
  },
  {
    question:
      "Do your bots incorporate my current exchange portfolio into their operations, or do they begin by establishing a new portfolio?",
    answer:
      "Yes, they can incorporate your current exchange portfolio into their operations.",
  },
];

function BotFaq() {
  const navigate = useNavigate();

  return (
    <div className={styles.helpWrapper}>
      <div className={styles.backBtn} onClick={() => navigate("/faq/all")}>
        <BiChevronLeft />
        <span>Back to Help Center</span>
      </div>

      <div className={`${styles.heroCard} ${styles.heroBot}`}>
        <div className={`${styles.heroIcon} ${styles.heroIconBot}`}>
          <MdOutlineSmartToy />
        </div>
        <div className={styles.heroContent}>
          {/* <div className={styles.heroEyebrow}>
            <MdOutlineHelpOutline />
            Bot Help Center
          </div> */}
          <h3 className={styles.heroTitle}>Bot Frequently Asked Questions</h3>
          <p className={styles.heroDesc}>
            Everything you need to know about creating, configuring, and
            deploying automated AI trading bots.
          </p>
        </div>
      </div>

      <div className={styles.faqCard}>
        <div className={styles.faqCardHeader}>
          <div className={styles.faqCardBadge}>
            <MdOutlineHelpOutline />
          </div>
          <div>
            <h4 className={styles.faqCardTitle}>Common Questions</h4>
            <p className={styles.faqCardSubtitle}>
              Answers to the most frequently asked questions about our trading
              bot features.
            </p>
          </div>
        </div>

        <ul className={styles.faqList}>
          {questions.map((faq, index) => (
            <FaqItem key={index} {...faq} id={index} />
          ))}
        </ul>
      </div>
    </div>
  );
}

export default BotFaq;
